import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_URL, ADMIN_URL } from '../../_common/constants';
import { CommonService } from 'src/app/_services/common.service';
import { ModalService } from 'src/app/_services/modal.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient, private commonService: CommonService, private modalService: ModalService) { }

  activateUser(guid: string, password: string) {    
    return this.http.post<any>(ADMIN_URL.Activation, { "uid": guid, "password": password }, {observe: 'response'})
      .pipe(map(response => {
          console.warn("User has been activated successfully for GUID : " + guid);
          return response;
      }));
  }

  validatePendingUser(uid: string):Observable<HttpResponse<any>> {
    return this.http.get<any>(ADMIN_URL.ValidateUser + "?UId=" + uid, {observe: 'response'})
        .pipe(map(response => {
            return response;
        }));
  }

  openModal(modalType, modalName) {
    if(modalType === 'error'){
      this.modalService.openErrorModal();
    } else {
      this.modalService.openModal(modalName);
    }
  }

  closeModal() {
    this.modalService.closeModal();
  }

  hasOpenModals() {
    return this.modalService.hasOpenModals();
  }
}
